import {
  enGB,
  enUS,
  de,
  da,
  ru,
  ar,
  it,
  frCA,
  fr,
  es,
  pt,
  ptBR,
  ja,
  ko,
  nl,
  nb,
  zhCN,
  zhHK,
  zhTW,
  id as idID,
  th,
  vi,
  pl,
  ro,
  cs,
  he,
  el,
  tr,
  hu,
  sv,
} from 'date-fns/locale'

export const supportedDateFnsLocales = {
  enUS,
  enGB,
  de,
  da,
  ru,
  ar,
  it,
  frCA,
  fr,
  es,
  ptBR,
  pt,
  ja,
  ko,
  nl,
  nb,
  zhCN,
  zhHK,
  zhTW,
  idID,
  th,
  vi,
  pl,
  ro,
  cs,
  he,
  el,
  tr,
  hu,
  sv,
}

type LocaleKey = keyof typeof supportedDateFnsLocales

export const getDateFnsLocale = (locale?: string) => {
  if (typeof locale !== 'string') {
    return locale ?? enUS
  }

  const [lang, region] = locale.includes('_') ? locale.split('_') : locale.split('-')

  const dateFnsLocale =
    supportedDateFnsLocales[(lang + region) as LocaleKey] ??
    supportedDateFnsLocales[lang as LocaleKey]

  return dateFnsLocale
}
